import styled from 'styled-components'
import { Table } from 'antd'
import { greys } from 'assets/themes/theme-default'

const AntTableStyled = styled(Table)`
  &&& {
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
      background: ${greys.light1};
      color: ${greys.light4};
    }
    ant-table-placeholder {
      border-bottom: 0 none;
    }
  }
`

export default AntTableStyled
